package core.enums

import core.util.ColourHelper

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 14.10.22
 * Author : marcusspors
 */
sealed class EImages(private val mName: String) {
    // ----------------------------------------------------------------------------
    // Enumeration List
    // ----------------------------------------------------------------------------

    object ALPINA_LOGO : EImages("alpinalogo.svg")
    object SHUFFLE_ICON : EImages("shuffle_icon.svg")
    object CAMERA_ICON : EImages("camera-icon.svg")
    object FIXED_ICON : EImages("fixed_icon.svg")
    object COLOURFINDER_ICON : EImages("colourfinder-icon.svg")
    object PAINT_ROLLER_SMALL : EImages("paint_roller_small.svg")
    class WATCHLIST_ICON(mColor: EColor, mType: EType) :
        EImages("watchlist_${mType.mValue}_list_icon_${mColor.mValue}.svg")

    class PAINT_BUCKET(mColor: EColor, mType: EType) : EImages("paintBucket_${mType.mValue}_${mColor.mValue}.svg")
    object DELETE_ICON_BLACK : EImages("delete_icon_black.svg")
    object DELETE_ICON_WHITE : EImages("delete_icon_white.svg")
    object CLOSE_ICON_WHITE : EImages("close_icon_white.svg")
    object CLOSE_ICON_GREY : EImages("close_icon_grey.svg")
    class WATCHLIST_ICON_TOP_APP_BAR(mType: EType) : EImages("watchlist_${mType.mValue}_list_icon_black.svg")
    class PAINTBUCKET_ICON_TOP_APP_BAR(mType: EType) : EImages("painBucketIcon_top_app_bar_${mType.mValue}.svg")
    object SLIDER_IMAGE_1 : EImages("slider/alpina_slider_01.png")
    object SLIDER_IMAGE_2 : EImages("slider/alpina_slider_02.png")
    object SLIDER_IMAGE_3 : EImages("slider/alpina_slider_03.png")
    object SLIDER_IMAGE_4 : EImages("slider/alpina_slider_04.png")
    object HEADER_IMAGE_S02 : EImages("slider/header_s02.png")

    object HEADER_IMAGE_S02_NEW : EImages("slider/header_s02_new.png")
    object HEADER_IMAGE_S06 : EImages("slider/header_s06.png")
    object SECOND_PRIMARY_BUTTON_IMAGE : EImages("second_primary_button_image.svg")
    class PAINT_ROLLER(mType: EType) : EImages("paint_roller_${mType.mValue}.svg")
    class EYE_ICON(mType: EType) : EImages("eye_${mType.mValue}.svg")
    object SLIDER_ARROW_LEFT : EImages("slider_arrow_left_icon.svg")
    object SLIDER_ARROW_RIGHT : EImages("slider_arrow_right_icon.svg")
    class DOWNLOAD_ICON(mColor: EColor) : EImages("download_icon_${mColor.mValue}.svg")
    object TABLER_ARROW_RIGHT : EImages("tabler-icon-chevron-right.svg")
    object TABLER_ARROW_LEFT : EImages("tabler-icon-chevron-left.svg")
    object TOUR_STAGE_1_BG_1 : EImages("tour/stage1_bg1.svg")
    object TOUR_STAGE_1_CAMERA : EImages("tour/stage1_camera.svg")
    object TOUR_STAGE_1_FLASH : EImages("tour/stage1_flash.svg")

    object TOUR_STAGE_1_BG_2 : EImages("tour/stage1_bg2.svg")
    object TOUR_STAGE_1_CAMERA2 : EImages("tour/stage1_camera2.svg")

    object TOUR_STAGE_1_IMG_LHS1 : EImages("tour/stage1_img_lhs1.svg")

    object TOUR_STAGE_1_IMG_RHS1 : EImages("tour/stage1_img_rhs1.svg")
    object TOUR_STAGE_1_IMG_LHS2 : EImages("tour/stage1_img_lhs2.svg")
    object TOUR_STAGE_1_BACKGROUND : EImages("tour/stage1/tour_forest_background.png")
    object TOUR_STAGE_1_HAND_WITH_PHONE_FOREST : EImages("tour/stage1/hand_with_phone_forest.png")
    object TOUR_STAGE_1_CAM_INDICATOR : EImages("tour/stage1/cam_indicator.svg")
    object TOUR_STAGE_1_CAM_INDICATOR_PRESSED : EImages("tour/stage1/cam_indicator_pressed.svg")
    object TOUR_STAGE_2_COLOUR_FAN : EImages("tour/stage2/stage2_colour_fan.svg")
    object TOUR_STAGE_2_COLOUR_FAN2 : EImages("tour/stage2/stage2_colour_fan2.svg")
    object TOUR_STAGE_2_COLOUR_FAN_BLUE1 : EImages("tour/stage2/stage2_colour_fan_blue1.svg")
    object TOUR_STAGE_2_COLOUR_FAN_BLUE2 : EImages("tour/stage2/stage2_colour_fan_blue2.svg")
    object TOUR_STAGE_2_COLOUR_FAN_BLUE3 : EImages("tour/stage2/stage2_colour_fan_blue3.svg")
    object TOUR_STAGE_2_COLOUR_FAN_BLUE4 : EImages("tour/stage2/stage2_colour_fan_blue4.svg")
    object TOUR_STAGE_2_MARKER1 : EImages("tour/stage2/stage2_marker1.svg")
    object TOUR_STAGE_2_MARKER2 : EImages("tour/stage2/stage2_marker2.svg")
    object TOUR_STAGE_2_MARKER3 : EImages("tour/stage2/stage2_marker3.svg")
    object TOUR_STAGE_2_MARKER4 : EImages("tour/stage2/stage2_marker4.svg")
    object TOUR_STAGE_2_UPPER_IMAGE : EImages("tour/stage2/stage2_upper_image.svg")
    object TOUR_STAGE_3_FARBRAUM_1 : EImages("tour/stage3/farbraum_1_background.png")
    object TOUR_STAGE_3_HAND_WITH_PHONE_FARBRAUM_1 : EImages("tour/stage3/farbraum_1.png")
    object TOUR_STAGE_3_HAND_WITH_PHONE_FARBRAUM_2 : EImages("tour/stage3/farbraum_2.png")
    object TOUR_STAGE_3_HAND_WITH_PHONE_FARBRAUM_3 : EImages("tour/stage3/farbraum_3.png")
    object TOUR_STAGE_4_BUCKET_COLOR_1 : EImages("tour/stage4/bucket_color_626452.svg")
    object TOUR_STAGE_4_BUCKET_COLOR_2 : EImages("tour/stage4/bucket_color_C7C4BF.svg")
    object TOUR_STAGE_4_BUCKET_COLOR_3 : EImages("tour/stage4/bucket_color_454443.svg")
    object TOUR_STAGE_4_BUCKET_COLOR_4 : EImages("tour/stage4/bucket_color_A09744.svg")
    object TOUR_STAGE_4_BUCKET_COLOR_5 : EImages("tour/stage4/bucket_color_809461.svg")
    object TOUR_CARD_INDICATOR1 : EImages("tour/card/card_indicator_1.svg")
    object TOUR_CARD_INDICATOR2 : EImages("tour/card/card_indicator_2.svg")
    object TOUR_CARD_INDICATOR3 : EImages("tour/card/card_indicator_3.svg")
    object TOUR_CARD_INDICATOR4 : EImages("tour/card/card_indicator_4.svg")
    class SHOPPING_CART_ICON(mColor: EColor, mType: EType ) : EImages("shopping_cart_icon_${mType.mValue}_${mColor.mValue}.svg")
    class SHARE_ICON(mColor: EColor) : EImages("share_icon_${mColor.mValue}.svg")
    object LOADING_SPINNER_ROLLER : EImages("loading/roller_orange.svg")
    object COLOURWALL_ICON: EImages("colourwall-icon.svg")
    object COLOUR_ON_WALL_ICON: EImages("colour-on-wall-icon.svg")
    object ARROW_BACK: EImages("arrow_back_black.svg")
    ;
    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    var mRelativePath: String = "/static/images/${this.mName}"

    enum class EColor(val mValue: String) {
        BLACK("black"),
        WHITE("white"),
        GRAY("gray")

        ;

        companion object {
            fun fromColorHex(hex: String): EColor {
                return if (ColourHelper.getContrastIsBlack(hex)) BLACK else WHITE
            }
        }
    }

    enum class EType(val mValue: String) {
        FILLED("filled"),
        OUTLINED("outlined"),

        ;

        companion object {
            fun fromIsOnList(isOnList: Boolean): EType {
                return if (isOnList) FILLED else OUTLINED
            }
        }
    }


    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------
}